/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MonetaryBreakdown } from './MonetaryBreakdown';
import {
    MonetaryBreakdownFromJSON,
    MonetaryBreakdownFromJSONTyped,
    MonetaryBreakdownToJSON,
    MonetaryBreakdownToJSONTyped,
} from './MonetaryBreakdown';
import type { ConsequenceTypeEnum } from './ConsequenceTypeEnum';
import {
    ConsequenceTypeEnumFromJSON,
    ConsequenceTypeEnumFromJSONTyped,
    ConsequenceTypeEnumToJSON,
    ConsequenceTypeEnumToJSONTyped,
} from './ConsequenceTypeEnum';

/**
 * 
 * @export
 * @interface IndividualConsequence
 */
export interface IndividualConsequence {
    /**
     * 
     * @type {number}
     * @memberof IndividualConsequence
     */
    id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IndividualConsequence
     */
    partyId: number;
    /**
     * Full name of the individual receiving the consequence (single party only)
     * @type {string}
     * @memberof IndividualConsequence
     */
    individualName: string;
    /**
     * Type of consequence
     * @type {ConsequenceTypeEnum}
     * @memberof IndividualConsequence
     */
    consequenceType: ConsequenceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IndividualConsequence
     */
    amount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IndividualConsequence
     */
    duration?: string | null;
    /**
     * Description of the consequence
     * @type {string}
     * @memberof IndividualConsequence
     */
    description: string;
    /**
     * 
     * @type {MonetaryBreakdown}
     * @memberof IndividualConsequence
     */
    monetaryBreakdown?: MonetaryBreakdown | null;
    /**
     * 
     * @type {Date}
     * @memberof IndividualConsequence
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IndividualConsequence
     */
    updatedAt?: Date | null;
}



/**
 * Check if a given object implements the IndividualConsequence interface.
 */
export function instanceOfIndividualConsequence(value: object): value is IndividualConsequence {
    if (!('partyId' in value) || value['partyId'] === undefined) return false;
    if (!('individualName' in value) || value['individualName'] === undefined) return false;
    if (!('consequenceType' in value) || value['consequenceType'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function IndividualConsequenceFromJSON(json: any): IndividualConsequence {
    return IndividualConsequenceFromJSONTyped(json, false);
}

export function IndividualConsequenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndividualConsequence {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'partyId': json['party_id'],
        'individualName': json['individual_name'],
        'consequenceType': ConsequenceTypeEnumFromJSON(json['consequence_type']),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'description': json['description'],
        'monetaryBreakdown': json['monetary_breakdown'] == null ? undefined : MonetaryBreakdownFromJSON(json['monetary_breakdown']),
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

export function IndividualConsequenceToJSON(json: any): IndividualConsequence {
    return IndividualConsequenceToJSONTyped(json, false);
}

export function IndividualConsequenceToJSONTyped(value?: IndividualConsequence | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'party_id': value['partyId'],
        'individual_name': value['individualName'],
        'consequence_type': ConsequenceTypeEnumToJSON(value['consequenceType']),
        'amount': value['amount'],
        'duration': value['duration'],
        'description': value['description'],
        'monetary_breakdown': MonetaryBreakdownToJSON(value['monetaryBreakdown']),
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'updated_at': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
    };
}

